export default "__VITE_ASSET__Cp7lH0TN__"